var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCst({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66699 27.6247C5.66699 26.6854 6.04013 25.7845 6.70432 25.1203C7.36851 24.4561 8.26935 24.083 9.20866 24.083H28.3337",
    stroke: "#121216",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20866 2.83301H28.3337V31.1663H9.20866C8.26935 31.1663 7.36851 30.7932 6.70432 30.129C6.04013 29.4648 5.66699 28.564 5.66699 27.6247V6.37467C5.66699 5.43537 6.04013 4.53453 6.70432 3.87034C7.36851 3.20615 8.26935 2.83301 9.20866 2.83301V2.83301Z",
    stroke: "#121216",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCst);
export default __webpack_public_path__ + "static/media/cst.75b96e196de22e1dedf16c2787bc716a.svg";
export { ForwardRef as ReactComponent };